import {
  Component,
  HostListener
} from "@angular/core";
import { AddToHomeScreenService } from "@mft/add-to-homescreen-service/add-to-homescreen.service";
import {registerCustomElements} from '../../../Mojo.WebComponents/dist/mojo-webcomponents.es.js';


@Component({
    selector: "mojo-app",
    templateUrl: "./app.component.html",
    standalone: false
})
export class AppComponent {

  constructor(
    private readonly addToHomeScreenService: AddToHomeScreenService) {
    registerCustomElements();
  }

  //Listens to beforeInstallPrompt event being triggered
  @HostListener("window:beforeinstallprompt", ["$event"])
  onbeforeinstallprompt(e: any) {
    //Passes event to addToHomeScreenService
    this.addToHomeScreenService.addToHomeScreen(e);
  }
}
